import { TYPES } from "@actions/catalog-actions";
import INITIAL_STATE from "./initial-state";

const catalogReducer = (state = INITIAL_STATE.catalog, action) => {
  switch (action.type) {
    case TYPES.FILTER_RECENTLY_MODIFIED: {
      const { filter } = action;
      let filtersRecentlyModified = [...state.filtersRecentlyModified];

      if (filtersRecentlyModified.includes(filter)) {
        filtersRecentlyModified = filtersRecentlyModified.filter((f) => f !== filter);
      }

      filtersRecentlyModified.unshift(filter);

      return {
        ...state,
        filtersRecentlyModified,
      };
    }

    default:
      return state;
  }
};

export default catalogReducer;
